module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraBold.7ad9a3c5.ttf";